
import { ref, toRef, computed } from 'vue'
import { useStore } from 'vuex'
import { PermissionMap } from '@/utils/auth'

export default {
  name: 'CoverBlock',
  props: {
    title: String,
    src: String,
    data: Object,
    type: String,
    copy: Function,
    del: Function,
    edit: Function
  },
  setup (props, { emit }) {
    const store = useStore()
    const isHover = ref(false)
    const bookType = computed({
      get: () => props.type,
      set: v => {
        console.log(333333, v)
      }
    })
    const current = toRef(props, 'data')
    const coverLock = ref(false)
    const handleMouseEnter = () => {
      if (!coverLock.value) {
        isHover.value = true
      }
    }
    const handleMouseLeave = () => {
      if (!coverLock.value) {
        isHover.value = false
      }
    }
    const handleCopy = () => {
      emit('copy')
    }
    const handleDeleteVisible = (e) => {
      coverLock.value = true
    }
    const handleDelete = () => {
      emit('del')
      coverLock.value = false
    }
    const handleVisibleChange = (visible) => {
      if (!visible) {
        coverLock.value = false
        isHover.value = false
      }
    }
    return {
      store,
      current,
      bookType,
      isHover,
      PermissionMap,
      handleMouseEnter,
      handleMouseLeave,
      handleCopy,
      handleDelete,
      handleVisibleChange,
      handleDeleteVisible
    }
  }
}
